const SHIPPING_METHOD_KEY_PARCEL = 'parcel';
const SHIPPING_METHOD_KEY_FREIGHT = 'freight';
const SHIPPING_METHOD_KEY_DEFAULT = SHIPPING_METHOD_KEY_PARCEL;
export { SHIPPING_METHOD_KEY_PARCEL };
export { SHIPPING_METHOD_KEY_FREIGHT };
export { SHIPPING_METHOD_KEY_DEFAULT };
